import axiosInstance from '@/shared/api/axios';
import type { ApiCategoriesGetResponse } from '@/shared/types/api/categories';

export const apiCategoriesGet = async (): Promise<ApiCategoriesGetResponse> => {
  const { data } = await axiosInstance.get<ApiCategoriesGetResponse>('/categories');
  return data;
};
